<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'ACCOUNT'" [breadcrumb]="''" [count]="0"
  icon="fa-user-circle">
</app-breadcrumb>
<div *ngIf="selectedUser">
  <div class="row">
    <div class="col-md-12">
      <app-user-detail #userDetail [isAdmin]="false" [selectedUser]="selectedUser">
      </app-user-detail>
    </div>
  </div>
  <div class="text-center text-nowrap" *ngIf="!userDetail.isLoading">
    <button kendoButton type="button" class="m-2" (click)="cancel()">
      {{ 'CANCEL' | translate}}
    </button>
    <button appPreventClick kendoButton type="button" class="m-2"
      [disabled]="!userDetail.formValid() || !userDetail.formDirty()" (click)="userDetail.save()">
      {{ 'SAVE' | translate}}
    </button>
  </div>
</div>